// extracted by mini-css-extract-plugin
module.exports = {"ctaBox":"CtaBox_ctaBox__1pVDV","slim":"CtaBox_slim__1UWah","fadeIn":"CtaBox_fadeIn__39WJ3","scaleXin":"CtaBox_scaleXin__1AaXM"};